<template>
  <section class="contact-section ">
    <div class="contact-container">
      <!-- Left Side: Contact Info -->
      <div class="contact-info">
        <h3>Contact Info</h3>

        <div class="info-block">
          <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="83" height="83" rx="23.5" fill="url(#paint0_linear_41_791)" />
            <rect x="0.5" y="0.5" width="83" height="83" rx="23.5" stroke="url(#paint1_linear_41_791)" />
            <path
              d="M37.5 57H46.5C54 57 57 54 57 46.5V37.5C57 30 54 27 46.5 27H37.5C30 27 27 30 27 37.5V46.5C27 54 30 57 37.5 57Z"
              stroke="#F5F3EF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M27 43.4999H32.64C33.78 43.4999 34.815 44.1449 35.325 45.1649L36.66 47.8499C37.5 49.4999 39 49.4999 39.36 49.4999H44.655C45.795 49.4999 46.83 48.8549 47.34 47.8349L48.675 45.1499C49.185 44.1299 50.22 43.4849 51.36 43.4849H56.97"
              stroke="#F5F3EF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M39.5098 34.5H44.5048" stroke="#F5F3EF" stroke-width="1.8" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M38.25 39H45.75" stroke="#F5F3EF" stroke-width="1.8" stroke-linecap="round"
              stroke-linejoin="round" />
            <defs>
              <linearGradient id="paint0_linear_41_791" x1="0" y1="0" x2="101.016" y2="35.2807"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#1E1E1E" />
                <stop offset="1" stop-color="#121212" />
              </linearGradient>
              <linearGradient id="paint1_linear_41_791" x1="0.811593" y1="3.43324" x2="97.824" y2="35.9708"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#262626" />
                <stop offset="1" stop-color="#2C2C2C" />
              </linearGradient>
            </defs>
          </svg>

          <div>
            <p class="label">Mail Me</p>
            <p>moinmation2@gmail.com</p>
            <p>moinintel2@gmail.com</p>
          </div>
        </div>

        <div class="info-block">
          <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="83" height="83" rx="23.5" fill="url(#paint0_linear_41_827)" />
            <rect x="0.5" y="0.5" width="83" height="83" rx="23.5" stroke="url(#paint1_linear_41_827)" />
            <path
              d="M54 34.5V49.5C54 55.5 52.5 57 46.5 57H37.5C31.5 57 30 55.5 30 49.5V34.5C30 28.5 31.5 27 37.5 27H46.5C52.5 27 54 28.5 54 34.5Z"
              stroke="#F5F3EF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M45 32.25H39" stroke="#F5F3EF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M42.0008 52.65C43.2848 52.65 44.3258 51.6091 44.3258 50.325C44.3258 49.0409 43.2848 48 42.0008 48C40.7167 48 39.6758 49.0409 39.6758 50.325C39.6758 51.6091 40.7167 52.65 42.0008 52.65Z"
              stroke="#F5F3EF" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            <defs>
              <linearGradient id="paint0_linear_41_827" x1="0" y1="0" x2="101.016" y2="35.2807"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#1E1E1E" />
                <stop offset="1" stop-color="#121212" />
              </linearGradient>
              <linearGradient id="paint1_linear_41_827" x1="0.811593" y1="3.43324" x2="97.824" y2="35.9708"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#262626" />
                <stop offset="1" stop-color="#2C2C2C" />
              </linearGradient>
            </defs>
          </svg>


          <div>
            <p class="label">Contact Me</p>
            <p>+92 3124880231</p>
            <p>+92 3292273571</p>
          </div>
        </div>

        <div class="info-block">
          <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="83" height="83" rx="23.5" fill="url(#paint0_linear_41_836)" />
            <rect x="0.5" y="0.5" width="83" height="83" rx="23.5" stroke="url(#paint1_linear_41_836)" />
            <path
              d="M42.0003 44.1449C44.585 44.1449 46.6803 42.0496 46.6803 39.4649C46.6803 36.8802 44.585 34.7849 42.0003 34.7849C39.4156 34.7849 37.3203 36.8802 37.3203 39.4649C37.3203 42.0496 39.4156 44.1449 42.0003 44.1449Z"
              stroke="#F5F3EF" stroke-width="1.8" />
            <path
              d="M29.4296 36.735C32.3846 23.745 51.6296 23.76 54.5696 36.75C56.2946 44.37 51.5546 50.82 47.3996 54.81C44.3846 57.72 39.6146 57.72 36.5846 54.81C32.4446 50.82 27.7046 44.355 29.4296 36.735Z"
              stroke="#F5F3EF" stroke-width="1.8" />
            <defs>
              <linearGradient id="paint0_linear_41_836" x1="0" y1="0" x2="101.016" y2="35.2807"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#1E1E1E" />
                <stop offset="1" stop-color="#121212" />
              </linearGradient>
              <linearGradient id="paint1_linear_41_836" x1="0.811593" y1="3.43324" x2="97.824" y2="35.9708"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#262626" />
                <stop offset="1" stop-color="#2C2C2C" />
              </linearGradient>
            </defs>
          </svg>

          <div>
            <p class="label">Location</p>
            <p>Allama Rasheed Turabi Rd,<br />Wahid Colony, Karachi, Pakistan</p>
          </div>
        </div>
        <div class="order-override">
          <h3 style="margin-top: 8px;">Contact Info</h3>
          <div class="social-images">
            <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="83" height="83" rx="23.5" fill="url(#paint0_linear_43_894)" />
              <rect x="0.5" y="0.5" width="83" height="83" rx="23.5" stroke="url(#paint1_linear_43_894)" />
              <circle cx="41.9745" cy="41.9999" r="18.6581" stroke="white" stroke-width="1.8" />
              <path d="M23.3164 39.7789C30.8685 40.2231 47.8385 38.6238 55.3017 28.6729" stroke="white"
                stroke-width="1.8" />
              <path d="M60.6328 43.3328C53.8212 41.1116 37.9766 40.4896 29.0918 55.7715" stroke="white"
                stroke-width="1.8" />
              <path d="M35.3105 24.2305C39.4568 29.4133 48.2824 43.5993 50.4147 58.8812" stroke="white"
                stroke-width="1.8" />
              <defs>
                <linearGradient id="paint0_linear_43_894" x1="0" y1="0" x2="101.016" y2="35.2807"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#1E1E1E" />
                  <stop offset="1" stop-color="#121212" />
                </linearGradient>
                <linearGradient id="paint1_linear_43_894" x1="0.811593" y1="3.43324" x2="97.824" y2="35.9708"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#262626" />
                  <stop offset="1" stop-color="#2C2C2C" />
                </linearGradient>
              </defs>
            </svg>

            <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="83" height="83" rx="23.5" fill="url(#paint0_linear_43_902)" />
              <rect x="0.5" y="0.5" width="83" height="83" rx="23.5" stroke="url(#paint1_linear_43_902)" />
              <path
                d="M38.3348 41.0176C38.3348 41.0176 42.1631 40.7312 42.1631 36.2441C42.1631 31.7571 39.0317 29.5613 35.0602 29.5613H22V54.6601H35.0602C35.0602 54.6601 43.0319 54.9083 43.0319 47.2517C43.0319 47.2517 43.3755 41.0176 38.3348 41.0176ZM27.7568 34.0101H35.0602C35.0602 34.0101 36.8359 34.0101 36.8359 36.626C36.8359 39.2419 35.7953 39.6142 34.6115 39.6142H27.7568V34.0101ZM34.726 50.1922H27.7568V43.4807H35.0602C35.0602 43.4807 37.7047 43.452 37.7047 46.9271C37.7047 49.8294 35.7666 50.154 34.726 50.1922Z"
                fill="white" />
              <path d="M58.6309 31.0315H48.2725V34.1247H58.6309V31.0315Z" fill="white" />
              <path
                d="M53.6674 35.9385C44.0155 35.9385 44.0251 45.5809 44.0251 45.5809C44.0251 45.5809 43.3663 55.1755 53.6674 55.1755C53.6674 55.1755 62.2597 55.6719 62.2597 48.5022H57.8395C57.8395 48.5022 57.9827 51.204 53.8107 51.204C53.8107 51.204 49.3904 51.5 49.3904 46.8411H62.3933C62.3933 46.8411 63.8158 35.948 53.6579 35.948L53.6674 35.9385ZM49.3522 43.4805C49.3522 43.4805 49.8869 39.614 53.7725 39.614C57.6581 39.614 57.6008 43.4805 57.6008 43.4805H49.3522Z"
                fill="white" />
              <defs>
                <linearGradient id="paint0_linear_43_902" x1="0" y1="0" x2="101.016" y2="35.2807"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#1E1E1E" />
                  <stop offset="1" stop-color="#121212" />
                </linearGradient>
                <linearGradient id="paint1_linear_43_902" x1="0.811593" y1="3.43324" x2="97.824" y2="35.9708"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#262626" />
                  <stop offset="1" stop-color="#2C2C2C" />
                </linearGradient>
              </defs>
            </svg>

            <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="83" height="83" rx="23.5" fill="url(#paint0_linear_43_1017)" />
              <rect x="0.5" y="0.5" width="83" height="83" rx="23.5" stroke="url(#paint1_linear_43_1017)" />
              <rect x="24" y="24" width="36" height="36" rx="8" stroke="white" stroke-width="1.8" />
              <circle cx="42" cy="42" r="8" stroke="white" stroke-width="1.8" />
              <circle cx="52.5" cy="31.5" r="2.5" fill="white" />
              <defs>
                <linearGradient id="paint0_linear_43_1017" x1="0" y1="0" x2="101.016" y2="35.2807"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#1E1E1E" />
                  <stop offset="1" stop-color="#121212" />
                </linearGradient>
                <linearGradient id="paint1_linear_43_1017" x1="0.811593" y1="3.43324" x2="97.824" y2="35.9708"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#262626" />
                  <stop offset="1" stop-color="#2C2C2C" />
                </linearGradient>
              </defs>
            </svg>

          </div>
        </div>
      </div>

      <!-- Right Side: Contact Form -->
      <div class="contact-form">
        <div class="cta-header">
          <img src="@/assets/images/second-arrow.png" alt="Arrow" />
          <h2>
            Let’s work <span>together.</span>
          </h2>
        </div>

        <form @submit.prevent="submit">
          <input v-model="name" name="from_name" type="text" placeholder="Name *" required />
          <input v-model="email" name="from_email" type="email" placeholder="Email *" required />
          <input v-model="subject" name="subject" type="text" placeholder="Subject" />
          <textarea v-model="message" name="message" placeholder="Message *" required></textarea>
          <button type="submit" :disabled="sending">
            {{ sending ? 'Sending…' : 'Send message' }}
          </button>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import emailjs from 'emailjs-com';
emailjs.init(process.env.VUE_APP_EMAILJS_SERVICE_ID);
emailjs.init(process.env.VUE_APP_EMAILJS_USER_ID);


export default {
  name: 'ContactForm',
  data() {
    return {
      name: '',
      email: '',
      subject: '',
      message: '',
      sending: false
    };
  },
  methods: {
    async submit() {
      this.sending = true;
      try {
        await emailjs.send(
          process.env.VUE_APP_EMAILJS_SERVICE_ID,            // your Gmail service ID
          process.env.VUE_APP_EMAILJS_TEMPLATE_ID,     // the template ID you just created
          {
            name:  this.name,
            from_email: this.email,
            subject:    this.subject,
            message:    this.message
          }
        );
        this.name = this.email = this.subject = this.message = '';
      } catch (err) {
        console.error('EmailJS error:', err);
      } finally {
        this.sending = false;
      }
    }
  }
  
}
</script>

<style scoped>
.contact-section {
  padding: 80px 0;
  background: #111;
}

.contact-container {
  display: flex;
  justify-content: space-between;
  gap: 40px;
  max-width: 1240px;
  margin: 0 auto;
  flex-wrap: wrap;
  margin-top: 40px;
}

.contact-info {
  flex: 0.9;
  display: flex;
  flex-direction: column;
  gap: 0;
  color: #f5f3ef;
  min-width: 320px;
}

.contact-info h3 {
  font-size: 24px;
  font-weight: 400;
  margin-top: 0;
  margin-bottom: 48px;
  color: #F5F3EF;
}

.info-block {
  font-size: 18px;
  display: flex;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 48px;
  height: 84px;
}

.info-block p {
  margin-top: 0;
  margin-bottom: 5px;
  font-size: 18px;
  font-weight: 300;
  color: #f5f3ef;
}

.info-block .label {
  font-size: 18px;
  color: #444444;
  margin-bottom: 8px;
}

.info-block img {
  width: 84px;
  height: 84px;
}

.label {
  font-size: 14px;
  color: #7c7c7c;
  margin-bottom: 4px;
}

.social-images {
  display: flex;
  gap: 24px;
  margin-top: 0;
}

.social-images img {
  width: 80px;
  height: 80px;
  border-radius: 12px;
}

.contact-form {
  flex: 1;
  background: linear-gradient(109.25deg, #1E1E1E 0%, #121212 100%);
  border: 1px solid #2c2c2c;
  padding: 49px 40px;
  border-radius: 20px;
  position: relative;
  color: #fff;
  min-width: 320px;
}

.cta-header {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 48px;

}

.cta-header img {
  position: absolute;
  top: 0;
  right: 51px;
  width: 37.677425384521484px;
  height: 91.42840576171875px;

}

.cta-header h2 {
  font-size: 48px;
  font-weight: 400;
  margin: 0;
}

.cta-header span {
  color: #F63E02;
  font-weight: 400;
}

form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

input,
textarea {
  background: #F5F3EF05;
  border: 1px solid #F5F3EF05;
  border-radius: 8px;
  padding: 14px 16px;
  font-size: 18px;
  color: #444444;
  height: 34px;
  font-family: 'sora', sans-serif;
}

input::placeholder,
textarea::placeholder {
  color: #444444;
  font-weight: 300;
  font-size: 18px;
  font-family: 'sora', sans-serif;
}

textarea {
  resize: vertical;
  min-height: 100px;
}

button {
  background: #555;
  border: none;
  padding: 20px 20px;
  border-radius: 8px;
  color: #f5f3ef;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s ease;
}

button:hover {
  background: #F63E02;
}

@media (max-width: 1023px) {
  .contact-container {
    flex-direction: column;
    gap: 40px;
    padding: 0 16px;

  }

  .contact-info,
  .contact-form {
    width: 100%;
  }

  .contact-info h3 {
    text-align: center;
  }

  .cta-header {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .cta-header img {
    position: relative;
    top: unset;
    right: unset;
    margin-left: 10px;
    width: 24px;
    height: 40px;
  }

  .cta-header h2 {
    font-size: 24px;
  }

  .form {
    width: 100%;
  }

  input,
  textarea,
  button {
    width: 100%;
    box-sizing: border-box;
  }

  .info-block {
    gap: 12px;
  }

  .info-block img,
  .social-images img {
    width: 50px;
    height: 50px;
  }

  .social-images {
    gap: 12px;
  }

  .contact-section {
    padding: 40px 0;
  }
}

@media (max-width: 767px) {
  .contact-section {
    padding: 40px 16px;
    margin-top: 40px;
  }

  .contact-container {
    display: flex;
    flex-direction: column;
    gap: 48px;
  }

  .contact-info {
    display: contents;
    width: 100%;
    gap: 20px;
  }

  .contact-info h3 {
    margin-bottom: 0;
  }

  .info-block {
    gap: 12px;
    width: 100%;
    margin: 0;
  }

  .contact-form {
    order: 2;
    margin-top: 8px;
  }

  .order-override {
    order: 3;
  }

  .info-block p {
    font-size: 16px;
  }

  .info-block img {
    width: 100px;
    height: 100px;
  }

  .social-images {
    gap: 24px;
    margin-top: 40px;
    justify-content: center;
    text-align: center;
  }

  .social-images img {
    width: 84px;
    height: 84px;
  }

  .contact-form {
    width: 100%;
    padding: 32px 24px;
    box-sizing: border-box;
    border-radius: 20px;
    position: relative;
  }

  .cta-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
  }

  .cta-header h2 {
    font-size: 40px;
    font-weight: 500;
    line-height: 120%;
    margin: 0;
    color: #fff;
  }

  .cta-header span {
    color: #FF0000;
    display: block;
    font-weight: 500;
  }

  .cta-header img {
    position: absolute;
    top: 0;
    right: 35px;
    width: 40px;
    height: 100px;
    margin: 0;
    padding: 0;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  input,
  textarea,
  button {
    width: 100%;
    box-sizing: border-box;
    height: 61px;
  }

  button {
    margin-top: 10px;
  }
}
</style>